import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-alocated-soc-modal',
  templateUrl: './alocated-soc-modal.component.html',
  styleUrls: ['./alocated-soc-modal.component.scss'],
})
export class AlocatedSocModalComponent implements OnInit {
  isLoading = true;
  Errors = null;
  data = null;
  mode = null;
  Success = null;
  branchs = null;
  companies = null;
  socs = null;

  groupForm = new FormGroup({
    company_id: new FormControl('', Validators.required),
    branch_code: new FormControl('', Validators.required),
    soc_id: new FormControl('', Validators.required),
    id: new FormControl(null, Validators.required),
  });

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService
  ) {}

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const { branch_code, company_id, soc_id } = this.groupForm.value;
    this.auth.postAlocatedSoc(branch_code, company_id, soc_id).subscribe(
      (resSuccess) => {
        this.data = resSuccess;
        this.isLoading = false;

        if (this.data.success) {
          this.closeModal();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
        }
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }
  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    this.auth.getCompanies().subscribe(
      (resSuccess) => {
        this.companies = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getBranches().subscribe(
      (resSuccess) => {
        this.branchs = resSuccess;
        this.isLoading = false;
        console.log('branch', resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
    this.auth.getSocs().subscribe(
      (resSuccess) => {
        this.socs = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getAlocatedSoc().subscribe(
      (resSuccess) => {
        this.data = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  addNew() {
    this.mode = 'add';
  }
  edit(alocate) {
    this.mode = 'edit';
    this.groupForm.patchValue({
      soc_id: alocate.soc_id,
      branch_code: alocate.branch_code,
      company_id: alocate.company_id,
      // id: alocate.id ,
    });
    console.log(this.groupForm.value);
  }

  delete(title) {
    this.auth.delSet('/api/soc/allotedsoc/delete', title.soc_id).subscribe(
      (resSuccess) => {
        this.data = this.data.filter(
          (dattum) => dattum.soc_id !== title.soc_id
        );
        this._snackBar.open('Deleted Successfully', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      },
      (resErr) => {
        this._snackBar.open('Error try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }
}
